import React, { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconDisk = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 16 16"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.33333 2.75C3.17862 2.75 3.03025 2.81146 2.92085 2.92085C2.81146 3.03025 2.75 3.17862 2.75 3.33333L2.75 12.6667C2.75 12.8214 2.81146 12.9697 2.92085 13.0791C3.03025 13.1885 3.17862 13.25 3.33333 13.25L12.6667 13.25C12.8214 13.25 12.9697 13.1885 13.0791 13.0791C13.1885 12.9697 13.25 12.8214 13.25 12.6667L13.25 5.64399L10.356 2.75L3.33333 2.75ZM1.86019 1.86019C2.2509 1.46949 2.7808 1.25 3.33333 1.25L10.6667 1.25C10.8656 1.25 11.0563 1.32902 11.197 1.46967L14.5303 4.803C14.671 4.94366 14.75 5.13442 14.75 5.33333L14.75 12.6667C14.75 13.2192 14.5305 13.7491 14.1398 14.1398C13.7491 14.5305 13.2192 14.75 12.6667 14.75L3.33333 14.75C2.7808 14.75 2.25089 14.5305 1.86019 14.1398C1.46949 13.7491 1.25 13.2192 1.25 12.6667L1.25 3.33333C1.25 2.7808 1.46949 2.2509 1.86019 1.86019Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.91699 8.66675C3.91699 8.25253 4.25278 7.91675 4.66699 7.91675L11.3337 7.91675C11.7479 7.91675 12.0837 8.25253 12.0837 8.66675V14.0001C12.0837 14.4143 11.7479 14.7501 11.3337 14.7501C10.9194 14.7501 10.5837 14.4143 10.5837 14.0001V9.41675H5.41699L5.41699 14.0001C5.41699 14.4143 5.08121 14.7501 4.66699 14.7501C4.25278 14.7501 3.91699 14.4143 3.91699 14.0001L3.91699 8.66675Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.66699 1.25C5.08121 1.25 5.41699 1.58579 5.41699 2V4.58333L10.0003 4.58333C10.4145 4.58333 10.7503 4.91912 10.7503 5.33333C10.7503 5.74755 10.4145 6.08333 10.0003 6.08333L4.66699 6.08333C4.25278 6.08333 3.91699 5.74755 3.91699 5.33333L3.91699 2C3.91699 1.58579 4.25278 1.25 4.66699 1.25Z"
          fill="currentColor"
        />
      </SvgIcon>
    );
  })
);
